import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=ec3453aa&"
import script from "./Organisations.vue?vue&type=script&lang=js&"
export * from "./Organisations.vue?vue&type=script&lang=js&"
import style0 from "./Organisations.vue?vue&type=style&index=0&id=ec3453aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports